import AuthService from './AuthService';

class BackupService {
    async request(clientId, path = '', method = 'GET', body) {
        const base = (process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '').replace(/\/+$/, '');
        const response = await fetch(`${base}/admin/clients/${encodeURIComponent(clientId)}/backups${path}`, {
            method,
            headers: { Authorization: `Bearer ${AuthService.getAccessToken()}`, 'Content-Type': 'application/json' },
            ...(body === undefined ? {} : { body: JSON.stringify(body) }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : `HTTP ${response.status}`);
        return data;
    }
}
const backupService = new BackupService();
export default backupService;
